// Форматирование чисел и названий в «умном подборе утеплителя».
//
// Вынесено из компонентов, чтобы таблица и сводка над ней показывали одно и то
// же число одинаково: расхождение в округлении читается как расхождение в цене.

export const formatMoney = (value) => (
  Number.isFinite(value) ? Math.round(value).toLocaleString('ru-RU') : '—'
);

export const formatVolume = (value) => (
  value > 0 ? value.toLocaleString('ru-RU', { maximumFractionDigits: 3 }) : '—'
);

export const formatMeasure = (value, unit) => (
  value > 0 ? `${value.toLocaleString('ru-RU')} ${unit}` : '—'
);

// Название в справочнике несёт состав упаковки в скобках на конце: и толщина, и
// объём стоят в таблице своими колонками, поэтому хвост убираем.
//
// Скобки в названии бывают не только в хвосте: «Утеплитель Изолайф (IZOLIFE)
// LIGHT (компрессия 50%) 100х600х1200 мм (0,576 м3; 5,76 м2; 8 шт)». Шаблон
// `\(.*?\)$` съедал всё от ПЕРВОЙ скобки — ленивость тут не спасает, конец
// строки заставляет её растянуться до последней скобки. Весь Изолайф
// схлопывался в «Утеплитель Изолайф», и строки его марок становились
// неотличимы друг от друга.
//
// `[^()]*` не пускает совпадение через чужие скобки, поэтому отрезается ровно
// последняя группа.
export const shortName = (name) => String(name || '').replace(/\s*\([^()]*\)\s*$/, '').trim();
